import { OurContext } from '../../context';
import { PaymentStatus } from '../../generated-sources/payments-api';
import { getEpaymentDetails } from '../../lib/epayment';
import { ERRORS } from '../../lib/errors';
import { commitFSCP } from '../../lib/paymentService';
import { wait, PARAMS } from '../../lib/util';
import { ErrorDetails, ErrorType } from './error';

export async function completeThreeDS(
  context: OurContext
): Promise<[ErrorDetails, string] | [null, string]> {
  const errorRedirect = `${context.host}/checkout?${PARAMS.TOKEN}=${context.peApiAuth}&${PARAMS.CARD_PAGE_TOKEN}=${context.epaymentsApiAuth}`;
  try {
    const [err, response] = await Promise.all([wait(1000), commitFSCP(context)]).then(([, v]) => v);
    if (err) {
      return [{ type: ErrorType.UNKNOWN, devMessage: err?.message }, errorRedirect];
    }
    if (response?.status === PaymentStatus.Failed) {
      return [
        { type: ErrorType.PAYMENT_FAILED, failureReason: response.failureReason },
        errorRedirect,
      ];
    }

    const [epaymentErr, epaymentResponse] = await getEpaymentDetails(context);
    if (epaymentErr || epaymentResponse?.returnUrl == null) {
      return [{ type: ErrorType.UNKNOWN, devMessage: epaymentErr?.message }, errorRedirect];
    }
    return [null, epaymentResponse.returnUrl];
  } catch (e) {
    return [
      { type: ErrorType.UNKNOWN, devMessage: e instanceof Error ? e?.message : ERRORS.REFUSED },
      errorRedirect,
    ];
  }
}
